class Toggle {
  /**
   * @param root {HTMLElement}
   */
  constructor(root) {
    this.root = root

    /**
     *
     * @type {Element|HTMLInputElement}
     */
    this.control = this.root.querySelector('[data-sub-component="control"]')
    this.enableUrl = this.root.dataset.enableUrl || null
    this.disableUrl = this.root.dataset.disableUrl || null

    this.initialize()
  }

  initialize() {
    this.root.addEventListener('click', () => {
      if (this.isEnabled()) {
        this.disable()
      } else {
        this.enable()
      }
    })
  }

  isEnabled() {
    return this.control.checked
  }

  enable() {
    this.control.checked = true
    if (this.enableUrl) {
      this.request(this.enableUrl).catch(() => {
        this.control.checked = false
      })
    }
  }

  disable() {
    this.control.checked = false
    if (this.disableUrl) {
      this.request(this.disableUrl).catch(() => {
        this.control.checked = true
      })
    }
  }

  request(url) {
    this.root.dispatchEvent(new Event('requestStarted'))
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
        credentials: 'include'
      }).then(response => {
        if (response.status === 200) {
          this.root.dispatchEvent(new Event('toggleSwitched'))
          resolve()
        } else {
          return response.json().then(data => {
            this.root.dispatchEvent(new CustomEvent('toggleError', { detail: data }))
            reject(new Error('The toggle request failed'))
          })
        }
      }).catch(e => {
        this.root.dispatchEvent(new Event('toggleError'))
        reject(e)
      }).finally(() => {
        this.root.dispatchEvent(new Event('requestFinished'))
      })
    })
  }

  addEventListener(type, listener, options = false) {
    this.root.addEventListener(type, listener, options)
  }

  removeEventListener(type, listener, options = false) {
    this.root.removeEventListener(type, listener, options)
  }

  dispatchEvent(event) {
    return this.root.dispatchEvent(event)
  }
}

export { Toggle }
